export default __webpack_public_path__ + "static/default-3_500x500-0711ded4c115fcaefdac4ff01a9c164c.png";